import api from "./authInterceptor";

// Signup
export const createPlayer = (data) =>
  api.post("/api/v1/create-players", data);

// Login
export const login = (data) => api.post("/api/login", data);

// Forgot Password
export const forgotPassword = (data) =>
  api.post("/api/usr-forgot-password", data);

// Reset Password
export const resetPassword = (data) =>
  api.post("/api/usr-reset-password", data);

// Change Password (auth)
export const changePassword = (data) =>
  api.post("/api/user-pwd", data);

export const verifyPhoneNumber = (data) => {
  return api.post("/api/verify-phone-number", data);
};


export const updateProfile = (data) => {
  return api.post("/api/user/profile/update", data);
};

export const getUserProfile = () => {
  return api.get("/api/user/show");
};
